import { makeStyles } from '@material-ui/core/styles';

export const useViewLegalBlockStyles = makeStyles(theme => ({
  legalBlock: {
    flexGrow: 1,
    padding: `${theme.spacing(4)}px ${theme.spacing(1)}px`,
    overflow: 'hidden'
  }
}));
